(ns assemble.assets-page.drawer.folders
  (:require [assemble.component.drawer.hooks :as dh]
            [assemble.component.drawer.view :refer [drawer]]
            [assemble.resource.asset :as resource]
            [assemble.util :as util]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]))

(defui folders-drawer []
  (let [{:keys [folder-id folder-name]} (dh/use-drawer-folders-data)
        open? (dh/use-drawer-open? :folder)
        on-close #(rf/dispatch [:assemble.assets-page/folders-drawer-close])]
    ($ drawer
       {:name (when (some? folder-name)
                (util/basename folder-name))
        :show-move? false
        :show-archive? false
        :show-more? false
        :show-tabs? false
        :drawer-type-label "folder"
        :open? open?
        :on-rename (fn [new-value]
                     (js/Promise. (fn [resolve reject]
                                    (rf/dispatch [::resource/rename-folder resolve reject folder-id new-value]))))
        :on-close on-close})))
